import { IppUserInvite } from '@rcp/types';

export interface InviteUserState {
	userInvitation: IppUserInvite;
}
export const initialInviteUsersState: InviteUserState = {
	userInvitation: {} as IppUserInvite
};
